import React, { createContext, useContext, useEffect, useState } from "react";
import { enumsApi, metaApi } from "@/api/client";

const AppDataContext = createContext(null);

export function AppDataProvider({ children }) {
  const [enums, setEnums] = useState(null);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    enumsApi.all().then((r) => setEnums(r.data)).catch(() => {});
    metaApi.get().then((r) => setMeta(r.data)).catch(() => {});
  }, []);

  return (
    <AppDataContext.Provider value={{ enums, meta }}>
      {children}
    </AppDataContext.Provider>
  );
}

export const useAppData = () => useContext(AppDataContext) || { enums: null, meta: null };
